module.exports = __webpack_public_path__ + "img/Rectangle 30.c5ae7024.png";